<template>
    <div class="container">
        <navBar :title="title" @onClickLeft="handleBack">
        </navBar>
        <img class="plan_head" src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/plan_head1.png"
            alt="">
        <div class="list_container">
            <div class="list" v-for="(item, index) in list" :key="index" @click="show(item)">
                <div class="list_top">
                    <img class="icon_head" :src="item.head" alt="">
                    <div class="title">{{ item.name }}</div>
                    <div class="consult_btn">立即咨询</div>
                </div>
                <div class="list_bottom">{{ item.desc }}</div>
            </div>
        </div>
        <van-action-sheet v-model="showAction" :title="actionData.name">
            <div class="content">
                <div class="content_desc">{{actionData.desc}}</div>
                <img class="erCode" :src="actionData.erCode" alt="">
                <div class="action_toast">保存二维码，微信扫一扫添加</div>
                <!-- ?response-content-type=application/octet-stream -->
                <a class="recharge_btn" v-if="!iswx" :href= "`${actionData.erCode}`+'?response-content-type=application/octet-stream'" download>保存二维码</a>
                <div class="recharge_btn" v-if="iswx">长按图片保存二维码</div>
            </div>
        </van-action-sheet>
    </div>
</template>


<script>
import navBar from '../components/navBar.vue';


export default {
    components: {
        navBar,
    },
    data() {
        return {
            list: [],
            showAction: false,
            actionData: {},
            iswx:false,
            title:this.$route.meta.title
            
        }
    },
    created() {
        this.getList();
        this.iswx = this.WeiXin();
    },
    methods: {
        handleBack() {
            this.$router.go(-1);
        },
        WeiXin () {
            // 判断是否是微信内置浏览器
            let isWeiXin = () => {
                return (
                navigator.userAgent
                    .toLowerCase()
                    .indexOf('micromessenger') !== -1
                )
            }
            if (isWeiXin()) {
                return true
            } else {
                return false
            }
        },
        show(item) {
            this.actionData = item;
            this.showAction = true;
        },
        getList() {
            this.list = [
                {
                    head: "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/icon_head1.png",
                    erCode: "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/ercode1.png",
                    name: "Athena",
                    desc: "应用心理学硕士，高级职业规划师，6年以上培训与咨询经验，曾服务于知名央企、上市集团、互联网企业等。",
                },
                {
                    head: "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/icon_head2.png",
                    erCode: "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/ercode1.png",
                    name: "Camil",
                    desc: "具有IT、媒体、外贸、电池、培训、教育等行业多年工作经验， 擅长员工职业生涯规划、团队建设、组织沟通等。",
                },
                {
                    head: "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/icon_head3.png",
                    erCode: "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/ercode1.png",
                    name: "Viktoria",
                    desc: "在高校从事了十年的心理学教学、心理咨询、职业指导工作。对性格、职业、女性心理有较深的研究。",
                },
                {
                    head: "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/icon_head4.png",
                    erCode: "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/ercode1.png",
                    name: "Larson",
                    desc: "某大型外资企业专业培训师，拥有丰富的培训经验。服务过超600名学员， 授课风格技巧深受学员认可。",
                },
                {
                    head: "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/icon_head5.png",
                    erCode: "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/ercode1.png",
                    name: "Flum",
                    desc: "工商管理硕士研究生，心理咨询师（二级），对不同职业方向，提供专业的分析和指导，得到诸多咨询者的认可。",
                },
            ]
            // this.$api.entityCard.checkBindStatus({}).then(({success, data})=>{
            //     if(success) {
            //         // this.bindStatus = data.status == 1;
            //     }
            // })
        }
    },
}
</script>

<style lang="less" scoped>
.van-action-sheet__close {
    position: absolute;
    padding: 0;
    top: 0.7rem;
    right: 0.864rem;
    font-size: 20px;
}
.plan_head {
    width: 100%;
    display: block;
}

.list_container {
    background: #281F33;
    padding: 25px 16px;

    .list {
        margin-bottom: 25px;
        background: #FFFAF0;
        border-radius: 14px;
        border: 2px solid #EA8100;
        padding: 28px 28px;

        .list_top {
            position: relative;
            height: 86px;
            padding-left: 112px;

            .icon_head {
                position: absolute;
                top: 0;
                left: 0;
                width: 86px;
                height: 86px;
            }

            .title {
                font-size: 30px;
                color: #131313;
                font-weight: bold;
                padding-top: 10px;
            }

        }

        .consult_btn {
            position: absolute;
            top: 0;
            right: 0;
            width: 168px;
            height: 64px;
            background: #F47C01;
            border-radius: 32px;
            text-align: center;
            line-height: 64px;
            color: #fff;
            font-size: 26px;
        }

        .list_bottom {
            margin-top: 8px;
            font-size: 26px;
            color: #333333;
        }
    }
}

.content {
    padding: 22px 50px 50px;
    .content_desc {
        font-size: 26px;
        color: #333;
        margin: 0 auto 50px;
    }
    .erCode {
        width: 269px;
        height: 269px;
        margin: 0 auto 26px;
        display: block;
    }
    .action_toast {
        margin: 0 0 40px;
        font-size: 26px;
        color: #969696;
        text-align: center;
    }

    .recharge_btn {
        display: block;
        color: #fff;
        font-size: 30px;
        text-align: center;
        line-height: 80px;
        height: 80px;
        background: linear-gradient(90deg, #C94DF9 0%, #7E4CF8 100%);
        border-radius: 50px;
    }
}
</style>